<template>
	<div class="bar">
		<div class="bar_box">
			<div class="bar_left">
				<div class="bar_min">
					<span v-if="lang==1">景区地址：湖北省潜江市龙湾镇章华台路001号</span>
					<span v-if="lang==2">Area:001 Zhanghuatai Road, Longwan Town</span>
					<span v-if="lang==3">観光地住所：湖北省潜江市龍湾鎮章華台路001号</span>
					<span v-if="lang==4">관광지주소:호북성잠강시룡만진장화대로001호</span>
				</div>
				<div class="bar_min">
					
					<span v-if="lang==1">咨询电话：0728-3509116 | 救援电话：0728-3509118 | 投诉电话：0728-6234865</span>
					<span v-if="lang==2">seek：0728-3509116 | rescue：0728-3509118 | complaint：0728-6234865</span>
					<span v-if="lang==3">問い合わせ電話：0728-3509116｜救援電話：0728-3509118｜苦情：0728-6243865</span>
					<span v-if="lang==4">문의: 0728-3509116 / 구조전화: 0728-3509118 / 신고전화: 0728-6234865</span>
				</div>
				<div class="bar_min" @click="nuv()">
					<span v-if="lang==1">全国旅游监管服务平台：12345</span>
					<span v-if="lang==2">Tourism Supervision：12345</span>
					<span v-if="lang==3">サービスプラットフォーム：12345</span>
					<span v-if="lang==4">전국 관광 감독 관리 서비스 플랫폼：12345</span>
				</div>
			</div>
			<div class="bar_right">
				<div class="bar_min2"  @click="rescue()">
					CopyRight © 2023 lwgjkgyzgy All Rights Reserved.Design by:至上互动 <span @click.stop="ban()">ICP:鄂ICP备2023020247号-2</span>
				</div>
			</div>
		</div>
		
		
		<div class="riesun" v-if="riesunfalg" @click="close()">
			<div class="riesun_box">
				<img class="riesun_img" src="../static/home/riesun.png" alt="">
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				lang: 1,
				riesunfalg:false,
			}
		},
		created() {
			this.lang = JSON.parse(localStorage.getItem("langs")) || 1
		},
		methods:{
			nuv(){
				window.open('https://jbts.mct.gov.cn/',"_blank");
			},
			ban(){		//备案
				window.open('https://beian.miit.gov.cn/#/Integrated/index',"_blank");
			},
			// 名片
			rescue(){
				this.riesunfalg = true
			},
			close(){
				this.riesunfalg = false
			},
		},
		beforeDestroy(){	//退出页面时间
					
		}
	}
</script>

<style scoped lang="less">
	//
	.bar{
		position: absolute;
		bottom: 0;
		left: 0;
		z-index: 20;
		width: 1920px;
		height: 58px;
		background-image: url('../static/home/bar.png');
		background-repeat: no-repeat;
		background-size: 100% 100%;
		Box-shadow: 0px 0px 30px 0px #ededed;
	}
	.bar_box{
		margin: auto;
		width: 1800px;
		height: 58px;
		line-height: 58px;
		display: flex;
		font-size: 14px;
		color: #333333;
		justify-content: space-between;
	}
	.bar_left{
		display: flex;
	}
	.bar_min{
		margin-right: 12px;	
	}
	.bar_right{
		display: flex;
	}
	.bar_min2{
		margin-left: 12px;
	}
	
	//
	.riesun{
		position: fixed;
		z-index: 100;
		top: 0;
		left: 0;
		width: 1920px;
		height: 100vh;
		background-color: rgba(0, 0, 0, .5);
	}
	.riesun_box{
		width: 1000px;
		position: absolute;
		top: 50%;
		left: 50%;
		transform:translate(-50%,-50%);
		background-color: #363636;
	}
	.riesun_img{
		width: 100%;
	}
</style>